module.exports = __webpack_public_path__ + "static/media/expertise-footer@3x.49a232db.jpeg";